const version = '1.1.7';

module.exports = {
    version
};